/*
  Back in stock alerts that send themselves (product page "Notify me" form).

  Progressive enhancement over the form in sections/curator-product.liquid (#CuratorNotifyForm).
  Without this file the form still works the old way: a Shopify contact form that emails the shop.
  With it, the request goes to the mm-wishlist-sync service (/api/back-in-stock), which checks the
  variant with Shopify, stores the request for up to 90 days and sends one alert when the piece is
  back: an email, or a WhatsApp message when the shopper gave a mobile number.

  What it changes on the page
    The one field accepts an email or a 10 digit Indian mobile number (type, placeholder, label and
      the line above it are updated here, the markup is not touched).
    The DPDP consent checkbox inside the form must be ticked. If the checkbox is not in the markup
      this file does nothing at all, because nothing may be stored without consent.
    Success and errors show in the existing message element.

  Fallback: if the service cannot be reached (network error or a 5xx reply) and the shopper gave an
  email, the submit is handed back to the section's own contact form code, so the request is not lost.

  The section's own submit listener sits on the form. This file listens on the document in the capture
  phase, which always runs first, and stops the event there unless it is handing over.

  Words: every word this file shows comes from <script id="MmNotifyI18n"> (snippets/mm-notify-i18n.liquid,
  locale keys mm.notify.*), with the English text here as the fallback when the block or a key is
  missing. The same block carries the on/off switch (theme setting mm_notify_service_enabled): when it
  is off this file does nothing and the form stays a contact form.
*/
(function () {
  var ENDPOINT = 'https://mm-wishlist-sync.netlify.app/api/back-in-stock';
  var form = document.getElementById('CuratorNotifyForm');
  if (!form || form.dataset.mmNotifyReady) return;

  var WORDS = {};
  try {
    var wordsNode = document.getElementById('MmNotifyI18n');
    if (wordsNode) WORDS = JSON.parse(wordsNode.textContent) || {};
  } catch (e) { WORDS = {}; }
  if (WORDS.enabled === false) return;

  function t(key, fallback) {
    var text = WORDS[key];
    return (typeof text === 'string' && text && !/translation missing/i.test(text)) ? text : fallback;
  }

  var field = form.querySelector('[id^="CuratorNotifyEmail-"]');
  var consent = form.querySelector('.dpdp-consent__checkbox');
  if (!field || !consent) return;
  form.dataset.mmNotifyReady = 'true';

  var SEC = field.id.replace('CuratorNotifyEmail-', '');
  var msg = document.getElementById('CuratorNotifyMsg-' + SEC);
  var button = document.getElementById('CuratorNotifySubmit-' + SEC);
  var wrap = document.getElementById('CuratorNotifyMe-' + SEC);
  var handingOver = false;
  var busy = false;

  /* ---------- One field, email or mobile ---------- */
  form.noValidate = true; /* validated here, so a mobile number is not refused by type="email" */
  field.type = 'text';
  field.setAttribute('inputmode', 'email');
  field.setAttribute('autocomplete', 'email');
  field.setAttribute('autocapitalize', 'none');
  field.setAttribute('spellcheck', 'false');
  field.setAttribute('placeholder', t('placeholder', 'Email or 10 digit mobile'));
  field.setAttribute('aria-label', t('field_aria', 'Email or 10 digit mobile number'));
  if (msg) { msg.setAttribute('role', 'status'); msg.setAttribute('aria-live', 'polite'); }
  if (button) button.textContent = t('button', 'Notify me');
  if (wrap) {
    var title = wrap.querySelector('.curator-product__notify-me-title');
    if (title) title.textContent = t('title', 'Notify me when available');
    var desc = wrap.querySelector('.curator-product__notify-me-desc');
    if (desc) desc.textContent = t('description', 'Leave your email or mobile number and we will tell you once when this piece is back. Mobile numbers get a WhatsApp message.');
  }

  function show(text, kind) {
    if (!msg) return;
    msg.textContent = text;
    msg.className = 'curator-product__notify-me-msg ' + (kind === 'success' ? 'is-success' : 'is-error');
  }
  function setBusy(on) {
    busy = on;
    if (!button) return;
    button.disabled = on;
    button.textContent = on ? t('saving', 'Saving') : t('button', 'Notify me');
  }

  function isEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); }
  function mobileDigits(v) {
    if (!/^[\d\s+()-]+$/.test(v)) return '';
    var d = v.replace(/\D/g, '');
    if (d.length < 10 || d.length > 13) return '';
    d = d.slice(-10);
    return /^[6-9]\d{9}$/.test(d) ? d : '';
  }

  /* The section keeps the selected variant in a hidden input and embeds the product as JSON. */
  function currentVariantId() {
    var input = document.getElementById('CuratorVariantId-' + SEC);
    return input ? String(input.value || '') : '';
  }
  function productData() {
    try {
      var el = document.querySelector('[data-product-json]');
      return el ? JSON.parse(el.textContent) : null;
    } catch (e) { return null; }
  }
  function variantTitle(product, id) {
    var list = (product && product.variants) || [];
    for (var i = 0; i < list.length; i++) if (String(list[i].id) === id) return list[i].title || '';
    return '';
  }

  function track(channel, variantId) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('back_in_stock_request', { variant_id: variantId, channel: channel });
      }
    } catch (e) { /* ignore */ }
  }

  /* Hand the submit back to the section's own contact form code. */
  function handOver() {
    handingOver = true;
    try {
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    } finally { handingOver = false; }
  }

  document.addEventListener('submit', function (e) {
    if (e.target !== form || handingOver) return;
    e.preventDefault();
    e.stopPropagation();
    if (busy) return;

    var value = (field.value || '').trim();
    var email = isEmail(value);
    var mobile = email ? '' : mobileDigits(value);
    if (!email && !mobile) { show(t('invalid', 'Enter a valid email or a 10 digit mobile number.')); field.focus(); return; }
    if (!consent.checked) { show(t('consent_needed', 'Tick the consent box so we can save this.')); consent.focus(); return; }

    var product = productData();
    var variantId = currentVariantId();
    if (!product || !product.handle || !variantId) { handOver(); return; }

    setBusy(true);
    fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain' },
      body: JSON.stringify({
        variant_id: variantId,
        product_handle: product.handle,
        product_title: product.title || '',
        variant_title: variantTitle(product, variantId),
        contact: email ? value : mobile,
        consent: true
      })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) { return { status: r.status, body: j }; });
    }).then(function (res) {
      setBusy(false);
      if (res.status === 200 && res.body.ok) {
        show(t('success', res.body.message || 'You are on the list. We will tell you once when this piece is back.'), 'success');
        field.value = '';
        consent.checked = false;
        track(email ? 'email' : 'whatsapp', variantId);
        return;
      }
      if (res.status === 409) return show(t('back_already', 'Good news, this piece is back already. Refresh the page to add it to your tote.'), 'success');
      if (res.status === 429) return show(t('too_many', 'Too many tries. Wait a few minutes and try again.'));
      if (res.status === 404) return show(t('not_found', 'We could not find this piece. Refresh the page and try again.'));
      if (res.status === 400) return show(t('bad_request', 'Enter a valid email or a 10 digit mobile number, and tick the consent box.'));
      unreachable(email);
    }).catch(function () {
      setBusy(false);
      unreachable(email);
    });
  }, true);

  function unreachable(email) {
    if (email) return handOver();
    show(t('unreachable', 'We could not save that just now. Try again shortly, or leave your email instead.'));
  }
})();
